import React, { useCallback } from 'react';
//import PropTypes from 'prop-types';
import Modal from '~/components/Modal';
import FormHeader from '~/components/form/form-header';
import FormFooter from '~/components/form/form-footer';
import { useForm } from '~/hooks';
import { FormGroup } from '~/components/form';


/**
 * @typedef BookRecordValues
 * @property {number}   sectionId
 * @property {string}   titleOpinionId 'Your File Number'
 * @property {boolean}  addRecordBookFlag
 * @property {[object]} data
 * @property {boolean}  editRecord
 * 
 * 
 * @typedef FormState
 * @property {BookRecordValues} values The current form values
 */

/** @type {BookRecordValues} */
const defaultState = {
    id: 0,
    sectionId: 0,
    titleOpinionId: 0,   
    data: [],
    addRecordBookFlag: false,
    editRecord: false
};

const loadData = async (values, props) => {    
    let editMode= false;
    if(props.recordBookDetailData && Object.keys(props.recordBookDetailData).length > 0){
        editMode = true;
    }    
    return {
        ...values,
        ...props,
        recordedBooks: props.recordedBooks,
        book: editMode ? props.recordBookDetailData._data.book : '',
        pageNo: editMode ? props.recordBookDetailData._data.pageNo : '',       
        sectionId: values ? values.sectionId: 0, 
    };
};


const BookRecord= (props) => {

    const onLoad = useCallback((values, props) => {
        return loadData(values, props);
    }, [props.isModalOpen]);

    const { state, fieldActions } = useForm({
        initialState: { ...defaultState },
        props,
        onLoad,
        debug: true
    });     

    return (
        <div>
            <Modal
                isModalOpen={props.isModalOpen}
                className='bg-white p-4 rounded-md'
            >
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card my-3'>
                            <FormHeader headerTxt={`${props.headerTxt}`} />
                            <div className="card-body">                            
                                <div className="col-span-8 grid grid-cols-8 grid-flow-row gap-x-2 gap-y-4 text-sm mb-4">
                                    <FormGroup
                                        label="Book"
                                        required
                                        groupClassName="col-span-5"
                                        path='book'                 
                                        value={state.values.book}
                                        error={state.errors.book}
                                        {...fieldActions}
                                    />
                                    <FormGroup
                                        label="Page No."
                                        required
                                        groupClassName="col-span-3"
                                        path='pageNo'                 
                                        value={state.values.pageNo}
                                        error={state.errors.pageNo}
                                        {...fieldActions}
                                    />
                                        
                                        
                                    <div className="col-span-8 flex justify-end items-center">                                        
                                        <FormFooter
                                            cancelBtnTxt={'Cancel'}
                                            submitBtnTxt={
                                                props.editRecord ? 'Save' : 'Add'}
                                            onSubmit={() => {
                                                props.editRecord ? 
                                                    props.saveBook(state.values)
                                                    :
                                                    props.addBook(state.values);
                                            }}
                                            onCancel={props.onCancel}
                                        />                                    
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default BookRecord;

